// Module
var code = "<span class=\"toolbar-custom-icon\" :class=\"'toolbar-icon-' + icon\" :style=\"{ 'font-size': size ? size + 'px' : '' }\"></span>";
// Exports
module.exports = code;